/* External dependencies */
import { filter, Observable, switchMap } from 'rxjs';

/* Local dependencies */
import { GetUserActions, GetUserActionTypes, getUserFailed, GetUserRequest, getUserSucceeded } from './action';
import { setAuthenticatedClient } from '../../../../client/graphql';
import { getUserQuery } from './getUserQuery';

export function getUserEpic(action$): Observable<GetUserActions> {
  return action$.pipe(
    filter((action: GetUserActions) => action.type === GetUserActionTypes.GET_USER_REQUEST),
    switchMap((action: GetUserRequest) => getUser(action.input).then(getUserSucceeded).catch(getUserFailed)),
  );
}

export async function getUser(input) {
  const graphQLClient = await setAuthenticatedClient();
  try {
    const {
      data: { getUser: user },
    } = await graphQLClient.query({
      query: getUserQuery,
      variables: { input },
    });
    console.log('📦  GetUserRequest:', JSON.stringify(user, null, 2));

    return user;
  } catch (e) {
    throw new Error('Failed to get user data');
  }
}
